<template>
  <v-app-bar app class="primary">
    <v-app-bar-nav-icon v-if="accountAuthorized" class="hidden-md-and-up white--text"
                        @click="showDrawer"></v-app-bar-nav-icon>
    <div class="body-2 user-info" v-if="currentUser">
      <p class="text--contrast ma-1">id {{ currentUser.id }} {{ currentUser.email }}</p>
      <p class="text--contrast ma-1">
        <span v-if="usersCount===1">{{ currentUser.name }}</span>
        <v-menu offset-y class="ml-1" v-if="usersCount>1">
          <template v-slot:activator="{ on }">
            <a class="text--contrast" v-on="on">{{ currentUser.name }}</a>
          </template>
          <v-list dense>
            <v-list-item
              v-for="(user, index) in users"
              :key="index"
              @click="setCurrentUserId(user.id)"
            >
              <v-list-item-title>{{ user.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </p>
    </div>
    <v-spacer></v-spacer>
    <div class="toolbar-btns">
    <a v-if="currentUser && UISettings.allowRecords"
       class="text--contrast ma-2 body-2 hidden-xs-only"
       @click="setCreateJoinDialog(true)">+&nbsp;{{ 'record' | lang }}</a>
    <a v-if="currentUser && UISettings.allowRecords"
       class="text--contrast ma-2 body-2 hidden-sm-and-up"
       @click="setCreateJoinDialog(true)">+&nbsp;1</a>

    <div class="mc-balance">
      <router-link v-if="currentUser"
                   class="text--contrast ma-2 body-2 balans"
                   to="/operations">
        {{ currentUser.availableBalance.toLocaleString(lang) }}&nbsp;/&nbsp;<money
        :color-class="debtClass" :sum="currentDebt"></money>
      </router-link>

      <a style="display: block" v-if="hasBpLevel"
                   class="text--contrast ma-2 body-2 balans"
                   @click="openBpDialog">
        {{ 'bonuses' | lang }}: {{ currentUser.bonusBalance }}
      </a>
    </div>

    <!-- Кнопка ОПЛАТА -->
    <v-btn text v-if="isPaymentBtnActive"
      class="payment-btn"
      color="accent"
      v-bind:style="{padding: '0 7px'}"
      @click="setCreatePaymentDialog({})"
      >
        +&nbsp;{{ 'payment' | lang }}
    </v-btn>
    <!-- Кнопка с символом валюты -->
    <v-btn text v-if="isPaymentBtnActive"
      class="currency-btn"
      color="accent"
      v-bind:style="{padding: '0 7px'}"
      @click="setCreatePaymentDialog({})"
      >
        +&nbsp;{{ currencySymbol | lang }}
    </v-btn>
    <router-link v-if="!currentUser && hasLogin"
                 class="text--contrast ma-2 body-2"
                 to="/auth/login">{{ 'login' | lang }}
    </router-link>
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { initJivoSiteWidget } from '@/lib/jivoSiteWidgetHelpers';
import { getCurrencySymbol } from '@/lib/moneyHelpers';
import Money from '@/components/Money.vue';

export default {
  name: 'MainToolbar',
  components: { Money },
  computed: {
    hasBpLevel() {
      if (!this.currentUser) {
        return false;
      }

      const { bpLevel } = this.currentUser;
      return bpLevel && bpLevel.isActive;
    },
    hasLogin() {
      return window.location.hostname !== 'login.tvoyklass.com';
    },
    drawer: {
      get() {
        return this.$store.state.drawerShow && this.accountAuthorized;
      },
      set(value) {
        return this.$store.commit('setDrawerState', value);
      },
    },
    currentDebt() {
      const { currentUser } = this;
      if (currentUser && currentUser.invoicesStat) {
        return currentUser.invoicesStat.currentDebt || 0;
      }
      return 0;
    },
    debtClass() {
      return this.currentDebt > 0 ? 'mc-debt' : null;
    },
    currencySymbol() {
      return getCurrencySymbol();
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isPaymentBtnActive() {
      return this.currentUser
      && this.allowOnlinePayment
      && (this.UISettings.onlinePayment.depositOnBalans
      || (this.allowedClassIds && this.allowedClassIds.length));
    },
    ...mapGetters(['accountAuthorized', 'currentUser', 'usersCount', 'users', 'UISettings', 'jivoSiteWidgetUrl', 'previousUserId', 'allowOnlinePayment', 'lang', 'allowedClassIds']),
  },
  watch: {
    currentUser() {
      if (this.jivoSiteWidgetUrl && this.currentUser) {
        initJivoSiteWidget({
          currentUser: this.currentUser,
          widgetUrl: this.jivoSiteWidgetUrl,
          previousUserId: this.previousUserId,
        });
      }
    },
  },
  methods: {
    openBpDialog() {
      if (!this.currentUser.bpLevel.autoChange) return;
      const showCurrentLevel = this.currentUser.bpLevel.levelParams.showNameAndProgressLk;
      const showNextLevel = this.currentUser.nextBpLevel
        && (this.currentUser.nextBpLevel.params || {}).showNameAndProgressLk;
      if (showCurrentLevel || showNextLevel) {
        this.setBpProgressDialog({});
      }
    },
    showDrawer() {
      this.$store.commit('setDrawerState', true);
    },
    ...mapMutations(['setCurrentUserId', 'setCreateJoinDialog', 'setCreatePaymentDialog', 'setBpProgressDialog']),
  },
};
</script>

<style scoped>
  a {
    text-decoration: underline;
  }

  .balans {
    min-width: 50px;
    text-align: right;
  }

  .mc-debt {
    background-color: red;
  }

  .user-info {
    overflow: hidden;
  }

  .user-info p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .toolbar-btns {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    justify-content: space-between;
    display: -ms-flexbox;
    display: flex;
  }

  .currency-btn {
    display: none
  }

  @media (max-width: 319px) {
    .currency-btn {
      display: block;
    }

    .payment-btn {
      display: none;
    }
  }

  .mc-balance {
    display: flex;
    flex-direction: row;

    @media (max-width: 549px) {
      flex-direction: column;

      .balans {
        text-align: start;
      }

      a {
        margin: 0 !important;
      }
    }
  }
</style>
